import './index.less';
import * as React from 'react';
import classnames from 'classnames';

interface NoDataProps {
  type?: 'empty' | '404';
  prefixCls?: string;
  className?: string;
  style?: React.CSSProperties;
  text?: string;
}

const NoData: React.SFC<NoDataProps> = (props) => {
  const { prefixCls = 'mpc-no-data', type, text, className, style } = props;
  const classes = classnames(className, {
    [`${prefixCls}`]: true,
    [`${prefixCls}-${type}`]: !!type,
  });
  const iconClasses = classnames({
    [`${prefixCls}-icon`]: !!type,
    [`${prefixCls}-icon-${type}`]: !!type,
  });
  const textClasses = classnames({ [`${prefixCls}-text`]: !!type });
  return (
    <div className={classes} style={style}>
      {!!type && <div className={iconClasses} />}
      {!!text && <div className={textClasses}>{text}</div>}
    </div>
  );
};

export default NoData;
